import React from 'react'
import { Table } from 'semantic-ui-react'
import { Constants } from '../../../config/appConstants'

const attestIconBgColor = {
    [Constants.ATTESTATION_STATUS_APPROVED]: "#22C55E",
    [Constants.ATTESTATION_STATUS_REJECTED]: "#EF4444",
    [Constants.ATTESTATION_STATUS_OVERRIDE]: "#3B82F6",
    "": ""
};

export const RenderAttestation = (props) => {
    const color = attestIconBgColor[props.attestationStatus ?? ""];
    let attestationDisableClass = '';
    if(!props.isAllowAttestation || (!props.attestationStatus && props.timeCardStatus !== Constants.IN_PROGRESS && !props.isFromTimeCard)) {
        attestationDisableClass = 'attestationDisable';
    }

    return (
        <Table.Cell>
            <div className={`d-flex justify-content-center ${attestationDisableClass}`}>
                <div onClick={props.openAttestationModal} className={`d-flex justify-content-center fileEditOutline ${props.attestationStatus ? "attestIconWhiteColor" : ""}`} style={{ cursor: 'pointer', width: '20px', height: '20px', backgroundColor: color, alignItems: 'center' }}>
                    <span className="iconify pointerCurser" data-icon="uil:file-edit-alt" data-inline="false" ></span>
                </div>
            </div>
        </Table.Cell>
    )
}

export const AttestationApprovedText = (languageSelected) => {
    return (
        languageSelected === Constants.ATTESTATION_LANGUAGE_ENGLISH
            ?            <p>I certify that I have carefully reviewed my timecard and it accurately reflects all of the hours that I worked today. I further certify that I was given the opportunity to take all meal and rest breaks <span style={{ textDecoration: 'underline' }}>(if rest breaks are required under the applicable CBA <i>or applicable law</i>)</span> in accordance with company policies and applicable law.</p>
            :
                        <p>Certifico además que se me dio la oportunidad de tomar todos los descansos para comer y descansar <span style={{ textDecoration: 'underline' }}>(si se requieren descansos según el CBA <i>o ley applicable</i>)</span> de acuerdo con las pólizas de la empresa y la ley applicable.</p>
    )
}
